import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import SelectField from "../../Utils/SelectField";
import { LabelText } from "../../Utils/Input";
import { MultiSelectDropdown } from "./MultiSelectDropdown";
import React from "react";
import { drop } from "lodash";
import { CreatableSelectField } from "../../Utils/CreatableSelectField";

export const getDisplayName = (name) => {
    if (!name || typeof name !== "string") return "";
    const exceptionalName = {
        paymentManagement: "Payment",
        notificationManagement: "Notification Management",
        identityManagement: "Identity Provider",
        whatsAppManagement: "WhatsApp Management",
        taskManagement: "Tasks",
        ML: "ML Analytics",
        RetentionInterval: "Stale Session Expiry Time",
        SessionExpiryBuffer: "Session Expiry",
        TaskEnabled: "Tasks",
        BRMTaskEnabled: "BRM Task Integration",
        SelfcareEnabled: "Selfcare",
        BillingEnabled: "Billing Management",
        LLMEnabled: "LLM",
        Enabled: "Session Audit",
        MLEnabled: "ML Analytics",
        PolicyEnabled: "Policy Specifications",
        OrderEnabled: "Order Management",
        CustomerPrefix: "Account Number Prefix",
        taxEnabled: "Tax Management",
        csv: "CSV",
        WhatsAppEnable: "Whatsapp",
        UsageEventsPersistanceMode: "Usage Persistance Mode",
        Days: "Retention Period",
        SessionExpiryBufferValue: "Session Expiry Buffer Size",
        "Retention Period": "Chat retention"
    };

    if (exceptionalName[name]) return exceptionalName[name];

    let readable = name
        .replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
        .replace(/_/g, " ")
        .replace("."," ")
        .trim();
    readable = readable.charAt(0).toUpperCase() + readable.slice(1);
    return readable;
};

const handleSSOToggle = (e, setIsSSOEnabled) => {
    const isEnabled = e.target.checked;
    setIsSSOEnabled(isEnabled);

    // If you need to update the values object directly, you can also do:
    // This assumes you have a way to update the values object
    if (typeof setValues === "function") {
        setValues((prevValues) => ({
            ...prevValues,
            isSSOUser: isEnabled,
        }));
    }
};

const getOptions = (key, values) => {
    const datasetVersion = [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
    ]
    if (key === "datasetVersion")
        return datasetVersion;
    else
        return values.map(value => ({
            label: value.charAt(0).toUpperCase() + value.slice(1),
            value: value
        }));
}

export const renderField = (
    field,
    finalValues,
    setFinalValues,
    switchState,
    setSwitchState,
    isEdit,
    isSSOEnabled,
    setIsSSOEnabled,
    config,
    currencyCodes,
    displayLabel,
    domain,
    rbac,
    setRbac
) => {
    if (!field) return null;

    const { key, widget, value: options = [] } = field;
    const lowerType = widget?.toLowerCase();
    let dropdownoptions;
    if (lowerType === "select" || lowerType === "dropdown")
        dropdownoptions = (key === "CurrencyCode") ? currencyCodes : getOptions(key, field.value);
    if (key.startsWith("IdentityProvider.")) return null;
    if (config.name === "identityManagement") {
        const currentType = domain === "SGCAdmin" ? "SGC" : "Generic";
        const providerConfig = config.value.find(val => val.key === "IdentityProvider");
        const availableProviders = providerConfig?.value.filter(provider => {
            const providerEntry = config.value.find(val => val.key === `IdentityProvider.${provider}`);
            return providerEntry && providerEntry.type && providerEntry.type.includes(currentType);
        }) || [];
        const identityProviderOptions = [
            { label: "Keycloak", value: "Keycloak" },
            ...(switchState["IdentityProvider.Azure"] ? [{ label: "Azure SSO", value: "Azure" }] : []),
            ...(switchState["IdentityProvider.Google"] ? [{ label: "Google SSO", value: "Google" }] : []),
        ];

        return (
            <>
                {availableProviders.map((provider, idx) => (
                    <Col
                        lg={options.length > 2 ? 4 : 6}
                        md={12}
                        key={provider}
                    >
                        <Input
                            type="radio"
                            name="identityProvider"
                            className="me-2"
                            disabled={isEdit}
                            checked={switchState["IdentityProvider"] === provider}
                            onChange={(e) =>{
                                setSwitchState(prev => ({
                                    ...prev,
                                    IdentityProvider: provider,
                                    [`IdentityProvider.${provider}`]: !prev[`IdentityProvider.${provider}`],
                                }))
                            }}
                        />
                        {provider}
                    </Col>
                ))}

                {/* ZITADEL CONFIGURATION */}
                {switchState?.IdentityProvider === "Zitadel" && (
                    <Row className="mt-3">
                        <Col lg={12}>
                            <div className="ms-4">
                                <LabelText
                                    displayText="Zitadel Configuration"
                                    classLabelName="rv-text-color fw-semibold mb-2"
                                />

                                {/* SSO Toggle */}
                                <Row>
                                    <Col xxl={3}>
                                        <FormGroup>
                                            <LabelText
                                                htmlFor="zitadel-sso"
                                                className="text-danger"
                                                displayText="SSO"
                                            />
                                            <div className="d-flex align-items-center mt-2">
                                                <FormGroup switch>
                                                    <Input
                                                        type="switch"
                                                        className="rv-form-switch-input"
                                                        name="IdentityProvider.Zitadel"
                                                        checked={switchState["IdentityProvider.Zitadel"] === true}
                                                        onChange={(e) => {
                                                            setSwitchState(prev => ({
                                                                ...prev,
                                                                "IdentityProvider.Zitadel": !prev["IdentityProvider.Zitadel"]
                                                            }))
                                                            handleSSOToggle(e, setIsSSOEnabled)
                                                        }
                                                        }
                                                        disabled={isEdit}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                )}

                {/* KEYCLOAK CONFIGURATION */}
                {switchState?.IdentityProvider === "Keycloak" && (
                    <Row className="mt-3">
                        <Col lg={12}>
                            <div className="ms-4">
                                <LabelText
                                    displayText="Keycloak Configuration"
                                    classLabelName="rv-text-color fw-semibold mb-2"
                                />

                                {/* Azure SSO Toggle */}
                                <Row>
                                    <Col xxl={3}>
                                        <FormGroup>
                                            <LabelText
                                                htmlFor="azure-sso"
                                                className="text-danger"
                                                displayText="Azure SSO"
                                            />
                                            <div className="d-flex align-items-center mt-2">
                                                <FormGroup switch>
                                                    <Input
                                                        type="switch"
                                                        className="rv-form-switch-input"
                                                        name="IdentityProvider.Azure"
                                                        checked={switchState["IdentityProvider.Azure"] === true}
                                                        onChange={(e) => {
                                                            setSwitchState(prev => ({
                                                                ...prev,
                                                                "IdentityProvider.Azure": !prev["IdentityProvider.Azure"],
                                                                ...(e.target.checked && {
                                                                    "IdentityProvider.Google": false,
                                                                    "IdentityProvider.Google.clientId":"",
                                                                    "IdentityProvider.Google.clientSecret":""
                                                                })
                                                            }))
                                                            handleSSOToggle(e, setIsSSOEnabled)
                                                        }
                                                        }
                                                        disabled={isEdit}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </FormGroup>
                                    </Col>

                                    {/* Google SSO Toggle */}
                                    <Col xxl={3}>
                                        <FormGroup>
                                            <LabelText
                                                htmlFor="google-sso"
                                                className="text-danger"
                                                displayText="Google SSO"
                                            />
                                            <div className="d-flex align-items-center mt-2">
                                                <FormGroup switch>
                                                    <Input
                                                        type="switch"
                                                        className="rv-form-switch-input"
                                                        name="IdentityProvider.Google"
                                                        checked={switchState["IdentityProvider.Google"] === true}
                                                        onChange={(e) => {
                                                            setSwitchState(prev => ({
                                                                ...prev,
                                                                "IdentityProvider.Google": !prev["IdentityProvider.Google"],
                                                                ...(e.target.checked && {
                                                                    "IdentityProvider.Azure": false,
                                                                    "IdentityProvider.Azure.tenantId": "",
                                                                    "IdentityProvider.Azure.clientId":"",
                                                                    "IdentityProvider.Azure.clientSecret":""
                                                                })
                                                            }))
                                                            handleSSOToggle(e, setIsSSOEnabled)
                                                        }}
                                                        disabled={isEdit}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </FormGroup>
                                    </Col>

                                    {(switchState["IdentityProvider.Azure"] || switchState["IdentityProvider.Google"]) && (
                                        <Col xxl={3}>
                                            <FormGroup>
                                                <LabelText
                                                    displayText="Operator's IDP"
                                                    className="text-danger"
                                                />

                                                <SelectField
                                                    name="IdentityProvider.ActiveProvider"
                                                    value={identityProviderOptions.find(
                                                        option =>
                                                            option.value ===
                                                            rbac
                                                    )}
                                                    handleChange={(selectedOption) =>
                                                        setRbac(selectedOption.value)
                                                    }
                                                    placeholder="Select..."
                                                    options={identityProviderOptions}
                                                    isRVStyle={true}
                                                    isDisabled={isEdit}
                                                />
                                            </FormGroup>
                                        </Col>
                                )}
                                </Row>

                                {/* Dynamic SSO Configuration Fields */}
                                {["Azure", "Google"].map(provider => {
                                    if (switchState[`IdentityProvider.${provider}`] !== true) return null;

                                    // Get child fields for this provider
                                    const childFields = config.value.filter(val =>
                                        val.key.startsWith(`IdentityProvider.${provider}.`)
                                    );

                                    // Format field name for display
                                    const formatFieldName = (key) => {
                                        const fieldName = key.split('.').pop();
                                        return fieldName
                                            .replace(/([A-Z])/g, ' $1')
                                            .replace(/^./, str => str.toUpperCase())
                                            .trim();
                                    };

                                    // Determine column size based on number of fields
                                    const colSize = provider === "Azure" ? 4 : 6;

                                    return (
                                        <Row className="mt-3" key={provider}>
                                            <Col lg={12}>
                                                <div className="ms-4">
                                                    <LabelText
                                                        displayText={`${provider} Configuration`}
                                                        classLabelName="rv-text-color fw-semibold mb-3"
                                                    />
                                                    <Row>
                                                        {childFields.map(field => (
                                                            <Col xxl={colSize} key={field.key}>
                                                                <FormGroup>
                                                                    <LabelText
                                                                        htmlFor={field.key}
                                                                        displayText={formatFieldName(field.key)}
                                                                        className="text-danger"
                                                                    />
                                                                    <Input
                                                                        type={field.key.includes('secret') ? "password" : "text"}
                                                                        name={field.key}
                                                                        value={switchState[field.key] || ""}
                                                                        onChange={(e) =>
                                                                            setSwitchState(prev => ({
                                                                                ...prev,
                                                                                [field.key]: e.target.value
                                                                            }))
                                                                        }
                                                                        disabled={isEdit}
                                                                        placeholder={`Enter ${formatFieldName(field.key)}`}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    );
                                })}
                            </div>
                        </Col>
                    </Row>
                )}
            </>
        );
    }

    const colSize = config.value.length === 3 ? 4 : config.value.length === 2 ? 6 : 12;

    switch (lowerType) {

        case "toggle":
            return (
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">{getDisplayName(key)}</span>
                    <Input
                        type="switch"
                        className="rv-form-switch-input"
                        checked={!!switchState?.[key]}
                        onChange={() =>
                            setSwitchState(prev => ({
                                ...prev,
                                [key]: !prev[key],
                            }))
                        }
                    />
                </div>
            );

        case "radio":
            return (
                <>
                    {options.map((opt) => (
                        <Col
                            lg={options.length > 2 ? 4 : 6} md={12}
                            key={opt}
                        // className="d-flex align-items-center"
                        // style={{ minWidth: "45%" }}
                        >
                            <Input
                                type="radio"
                                name={key}
                                className="me-2"
                                checked={switchState?.[key] === opt}
                                onChange={() =>
                                    setSwitchState(prev => ({ ...prev, [key]: opt }))
                                }
                            />
                            <LabelText
                                displayText={opt}
                                classLabelName={"rv-text-color"}
                            />
                        </Col>
                    ))}
                </>
            );

        case "select":
        case "dropdown":
            return (
                <Col lg={colSize} md={12} className="mb-3">
                    <div>
                        {displayLabel && <LabelText
                            displayText={getDisplayName(key)}
                            classLabelName={"rv-text-color"}
                        />}
                        <p className="text-muted mt-0">
                            {dropdownoptions.some(opt => (opt.value === "days" || opt.value === "day")) ? "Select Time Period" : `Select ${getDisplayName(key)}`}
                        </p>
                        <SelectField
                            name={key}
                            value={
                                dropdownoptions?.find(
                                    (option) =>
                                        option.label ===
                                        switchState?.[key]
                                ) ||
                                switchState?.[key]
                            }
                            handleChange={(selectedOption) =>
                                setSwitchState(prev => ({
                                    ...prev,
                                    [key]: selectedOption,
                                }))
                            }
                            placeholder={"Select..."}
                            options={dropdownoptions}
                            isRVStyle={true}
                        />
                    </div>
                </Col>
            );

        case "creatable-select":
            return (
                <Col lg={colSize} md={12} className="mb-3">
                    <div>
                        {displayLabel && <LabelText
                            displayText={getDisplayName(key)}
                            classLabelName={"rv-text-color"}
                        />}
                        <p className="text-muted mt-0">
                            {`Select ${getDisplayName(key)}`}
                        </p>
                        <CreatableSelectField
                            className="me-2"
                            values={switchState.CustomerCategory}
                            placeholder={"Enter your Categories"}
                            handleChange={(selectedOption) =>
                                setSwitchState(prev => ({
                                    ...prev,
                                    [key]: selectedOption,
                                }))
                            }
                            onKeyDown={(event) => {
                                const key = event.key;
                                const regex = /^[a-zA-Z0-9\s_]$/;
                                if (
                                    regex.test(key) ||
                                    [
                                        "Backspace",
                                        "Delete",
                                        "ArrowLeft",
                                        "ArrowRight",
                                        "Enter",
                                    ].includes(key)
                                ) {
                                    return;
                                }
                                event.preventDefault();
                            }}
                            isMulti={true}
                            name={key}
                            fieldName={key}
                            isClearable={true}
                            isRVStyle={true}
                        />
                    </div>
                </Col>
            );
        case "text":
        case "string": {
            // how many input fields of this type exist in same config?
            const group = config.value?.filter(
                item =>
                    ["text", "string", "number"].includes(item?.widget?.toLowerCase())
            ) || [];

            const colSize =
                group.length === 3 ? 4 :
                    group.length === 2 ? 6 :
                        6;

            // Create a unique key by combining config name and field key
            // This prevents conflicts when same keys exist across different configs
            const uniqueKey = `${config.name}.${key}`;

            return (
                <Col lg={colSize} md={12} className="mb-3">
                    {(displayLabel || config.name === "Prefixes" || config.name === "SequenceHandling") && (
                        <LabelText
                            displayText={key === "Interval" ? "Retention Interval" : getDisplayName(key)}
                            classLabelName="fw-semibold"
                        />)}

                    {config.name === "Prefixes" || config.name === "SequenceHandling" ?
                        <p className="text-muted mt-0">
                            Enter A{" "}
                            {config.name === "Prefixes"
                                ? `Prefix (Eg., ${key
                                    .substr(0, 3)
                                    .toUpperCase()})`
                                : "Sequence Number(Eg., 101, 1002, 1113)"}{" "}
                            Up To{" "}
                            {config.name === "Prefixes"
                                ? 16
                                : 8}{" "}
                            Characters
                        </p> :
                        <p className="text-muted mt-0">
                            Enter {key === "SovereignAI" || key === "OpenAI" ? `${key} ${config.name.split(".")[1]}` : key === "Interval" ? "Retention Interval" : getDisplayName(key)}
                        </p>
                    }

                    <Input
                        type={lowerType === "number" ? "number" : "text"}
                        value={switchState?.[uniqueKey] || ""}
                        onChange={(e) =>
                            setSwitchState(prev => ({
                                ...prev,
                                [uniqueKey]: e.target.value
                            }))
                        }
                    />
                </Col>
            );
        }

        case "number":
            return (

                <Col lg={6} md={12}>
                    {displayLabel && <LabelText
                        displayText={field?.value?.length > 1 ? " " : getDisplayName(key)}
                        classLabelName="fw-semibold"
                    />}
                    {<p className="text-muted mt-0">
                        Enter Unit
                    </p>
                    }
                    <Input
                        type="number"
                        value={switchState?.[key] || ""}
                        onChange={(e) =>
                            setSwitchState(prev => ({ ...prev, [key]: e.target.value }))
                        }
                    />
                </Col>
            );

        case "checkbox": {
            const disabled =
                key === "BRMTaskEnabled" && !switchState["TaskEnabled"];

            const isBooleanCheckbox = options?.includes("true") || options?.includes("false");

            if (isBooleanCheckbox) {
                return (
                    <Col lg={config.value.length > 2 ? 4 : 6} md={8} className="mb-2">
                        <Input
                            type="checkbox"
                            className="rv-form-switch-input me-3"
                            disabled={disabled}
                            checked={!!switchState?.[key]}
                            onChange={() =>
                                setSwitchState(prev => ({
                                    ...prev,
                                    [key]: !prev[key],
                                }))
                            }
                        />
                        <LabelText
                            displayText={getDisplayName(key)}
                            classLabelName={"rv-text-color"}
                        />
                    </Col>
                );
            }

            return (
                <React.Fragment>
                    {options?.map((option, idx) => (
                        <Col lg={options.length > 2 ? 4 : 6} md={8} className="mb-2" key={`${key}-${option}-${idx}`}>
                            <Input
                                type="checkbox"
                                className="rv-form-switch-input me-3"
                                disabled={disabled}
                                checked={!!switchState?.[option]}
                                onChange={() =>
                                    setSwitchState(prev => ({
                                        ...prev,
                                        [option]: !prev[option],
                                    }))
                                }
                            />
                            <LabelText
                                displayText={getDisplayName(option)}
                                classLabelName={"rv-text-color"}
                            />
                        </Col>
                    ))}
                </React.Fragment>
            );
        }

        default:
            return null;
    }
};


